module.exports = __webpack_public_path__ + "static/img/img1.52dea31d.png";